import "./FormVarMatriz.css";
import HeaderLogoIcons from "../../components/headerLogoIcons/headerLogoIcons";
import FooterIndex from "../../components/footerHomePage/footerHomePage";
import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import UpdateLoader from "../../components/UpdateLoader/UpdateLoader";

const generateRefs = (
  count,
  fields = ["data", "minimum", "maximum", "value"]
) => {
  return Array(count)
    .fill(null)
    .map(() => {
      const obj = {};
      fields.forEach((field) => {
        obj[field] = React.createRef();
      });
      return obj;
    });
};

const FormVarMatriz = () => {
  const [LoaderTrueFalse, setLoaderTrueFalse] = useState(false);
  const [riskVariables, setRiskVariables] = useState({});
  const [loading, setLoading] = useState(true);

  const incomeRefs = generateRefs(7, ["data", "minimum", "maximum", "value"]);
  const typeCanalRefs = generateRefs(2, ["data", "value"]);
  const incomeLegalRefs = generateRefs(6, [
    "data",
    "minimum",
    "maximum",
    "value",
  ]);
  const geographicLocationRefs = generateRefs(2, ["data", "value"]);
  const activityBeingCarriedOutRefs = generateRefs(3, ["data", "value"]);
  const activitySeniorityRefs = generateRefs(3, ["data", "value"]);
  const typeOperationRefs = generateRefs(3, ["data", "value"]);
  const typeCustomerRefs = generateRefs(2, ["data", "value"]);
  const documentationRefs = generateRefs(1, ["data", "value"]);
  const mdrLowNumberRefs = generateRefs(1, [
    "data",
    "min_number",
    "max_number",
  ]);
  const mdrMidNumberRefs = generateRefs(1, [
    "data",
    "min_number",
    "max_number",
  ]);
  const mdrHighNumberRefs = generateRefs(1, [
    "data",
    "min_number",
    "max_number",
  ]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_RISK_VARIABLES}`);
        setRiskVariables(res.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (riskVariables === null) {
    return <div className="loader"></div>;
  }

  const handleSubmit = () => {
    setLoaderTrueFalse(true);
    // Recolectar datos de ingresos para Persona Humana
    const incomeData = incomeRefs.map((ref, index) => ({
      data: riskVariables.Income[index]?.data,
      minimum: ref.minimum.current.value,
      maximum: ref.maximum.current.value,
      value: ref.value.current.value,
    }));

    const incomeLegalData = incomeLegalRefs.map((ref, index) => ({
      data: riskVariables.IncomeLegal[index]?.data,
      minimum: ref.minimum.current.value,
      maximum: ref.maximum.current.value,
      value: ref.value.current.value,
    }));

    const geographicLocationData = geographicLocationRefs.map((ref, index) => ({
      data: riskVariables.GeographicLocation[index]?.data,
      value: ref.value.current.value,
    }));

    const typeCanalData = typeCanalRefs.map((ref, index) => ({
      data: riskVariables.Canal[index]?.data,
      value: ref.value.current.value,
    }));

    const activityBeingCarriedOutData = activityBeingCarriedOutRefs.map(
      (ref, index) => ({
        data: riskVariables.ActivityBeingCarriedOut[index]?.data,
        value: ref.value.current.value,
      })
    );

    const activitySeniorityData = activitySeniorityRefs.map((ref, index) => ({
      data: riskVariables.ActivitySeniority[index]?.data,
      value: ref.value.current.value,
    }));

    const typeOperationData = typeOperationRefs.map((ref, index) => ({
      data: riskVariables.TypeOperation[index]?.data,
      value: ref.value.current.value,
    }));

    const typeCustomerData = typeCustomerRefs.map((ref, index) => ({
      data: riskVariables.TypeCustomer[index]?.data,
      value: ref.value.current.value,
    }));

    const documentationData = documentationRefs.map((ref, index) => ({
      data: riskVariables.Documentation[index]?.data,
      value: ref.value.current.value,
    }));

    const mdrLowNumberData = mdrLowNumberRefs.map((ref, index) => ({
      data: riskVariables.MDRLowNumber[index]?.data,
      min_number: ref.min_number.current.value,
      max_number: ref.max_number.current.value,
    }));

    const mdrMidNumberData = mdrMidNumberRefs.map((ref, index) => ({
      data: riskVariables.MDRMidNumber[index]?.data,
      min_number: ref.min_number.current.value,
      max_number: ref.max_number.current.value,
    }));

    const mdrHighNumberData = mdrHighNumberRefs.map((ref, index) => ({
      data: riskVariables.MDRHighNumber[index]?.data,
      min_number: ref.min_number.current.value,
      max_number: ref.max_number.current.value,
    }));

    // Combinar todos los datos en un objeto
    const formData = {
      Income: incomeData,
      Canal: typeCanalData,
      IncomeLegal: incomeLegalData,
      GeographicLocation: geographicLocationData,
      ActivityBeingCarriedOut: activityBeingCarriedOutData,
      ActivitySeniority: activitySeniorityData,
      TypeOperation: typeOperationData,
      TypeCustomer: typeCustomerData,
      Documentation: documentationData,
      MDRLowNumber: mdrLowNumberData,
      MDRMidNumber: mdrMidNumberData,
      MDRHighNumber: mdrHighNumberData,
    };
    submitData(formData);
  };

  const submitData = async (formData) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_RISK_VARIABLES_UPDATE}`,
        formData
      );
      if (response.status === 200) {
        setLoaderTrueFalse(false);
        //si no hay probblemas da una aviso que se guardaron los datos
        Swal.fire({
          icon: "success",
          title: "Exito",
          text: "Se actualizaron las variables de riesgo!",
        });
      }
    } catch (error) {
      setLoaderTrueFalse(false);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.response.data.message,
      });
    }
  };

  return (
    <div className="heighresolve">
      <HeaderLogoIcons />
      {!loading ? (
        <>
          {LoaderTrueFalse === true ? <UpdateLoader /> : null}
          <div className="form-matriz-var">
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">
                  Ingresos (NSE) - Persona Humana
                </p>
              </div>
              <div className="box-input-matriz-var">
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo D2</label>
                    <input
                      ref={incomeRefs[0].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[0]?.minimum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo D2</label>
                    <input
                      ref={incomeRefs[0].maximum}
                      placeholder="Valor maximo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[0]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[0]?.data}
                    </label>
                    <input
                      ref={incomeRefs[0].value}
                      placeholder="Valor de la matriz (1 a 5)"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[0]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo D1</label>
                    <input
                      ref={incomeRefs[1].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[1]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo D1</label>
                    <input
                      ref={incomeRefs[1].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.Income[1]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[1]?.data}
                    </label>
                    <input
                      ref={incomeRefs[1].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.Income[1]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo C3</label>
                    <input
                      ref={incomeRefs[2].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[2]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo C3</label>
                    <input
                      ref={incomeRefs[2].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.Income[2]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[2]?.data}
                    </label>
                    <input
                      ref={incomeRefs[2].value}
                      className="inputvarmatriz"
                      placeholder="Valor de la matriz (1 a 5)"
                      type="text"
                      defaultValue={riskVariables.Income[2]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo C2</label>
                    <input
                      ref={incomeRefs[3].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[3]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo C2</label>
                    <input
                      ref={incomeRefs[3].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.Income[3]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[3]?.data}
                    </label>
                    <input
                      ref={incomeRefs[3].value}
                      className="inputvarmatriz"
                      placeholder="Valor de la matriz (1 a 5)"
                      type="text"
                      defaultValue={riskVariables.Income[3]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo C1</label>
                    <input
                      ref={incomeRefs[4].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[4]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo C1</label>
                    <input
                      ref={incomeRefs[4].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.Income[4]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[4]?.data}
                    </label>
                    <input
                      ref={incomeRefs[4].value}
                      className="inputvarmatriz"
                      placeholder="Valor de la matriz (1 a 5)"
                      type="text"
                      defaultValue={riskVariables.Income[4]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo B</label>
                    <input
                      ref={incomeRefs[5].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[5]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo B</label>
                    <input
                      ref={incomeRefs[5].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.Income[5]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[5]?.data}
                    </label>
                    <input
                      ref={incomeRefs[5].value}
                      className="inputvarmatriz"
                      placeholder="Valor de la matriz (1 a 5)"
                      type="text"
                      defaultValue={riskVariables.Income[5]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo A</label>
                    <input
                      ref={incomeRefs[6].minimum}
                      placeholder="Valor minimo de ingresos"
                      className="inputvarmatriz"
                      type="text"
                      defaultValue={riskVariables.Income[6]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo A</label>
                    <input
                      ref={incomeRefs[6].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.Income[6]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.Income[6]?.data}
                    </label>
                    <input
                      ref={incomeRefs[6].value}
                      className="inputvarmatriz"
                      placeholder="Valor de la matriz (1 a 5)"
                      type="text"
                      defaultValue={riskVariables.Income[6]?.value}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">
                  Ingresos (NSE) - Persona Jurídica
                </p>
              </div>
              <div className="box-input-matriz-var">
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo 6</label>
                    <input
                      ref={incomeLegalRefs[0].minimum}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor minimo de ingresos"
                      defaultValue={riskVariables.IncomeLegal[0]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo 6</label>
                    <input
                      ref={incomeLegalRefs[0].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.IncomeLegal[0]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.IncomeLegal[0]?.data}
                    </label>
                    <input
                      ref={incomeLegalRefs[0].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.IncomeLegal[0]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo 5</label>
                    <input
                      ref={incomeLegalRefs[1].minimum}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor minimo de ingresos"
                      defaultValue={riskVariables.IncomeLegal[1]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo 5</label>
                    <input
                      ref={incomeLegalRefs[1].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.IncomeLegal[1]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.IncomeLegal[1]?.data}
                    </label>
                    <input
                      ref={incomeLegalRefs[1].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.IncomeLegal[1]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo 4</label>
                    <input
                      ref={incomeLegalRefs[2].minimum}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor minimo de ingresos"
                      defaultValue={riskVariables.IncomeLegal[2]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo 4</label>
                    <input
                      ref={incomeLegalRefs[2].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.IncomeLegal[2]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.IncomeLegal[2]?.data}
                    </label>
                    <input
                      ref={incomeLegalRefs[2].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.IncomeLegal[2]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo 3</label>
                    <input
                      ref={incomeLegalRefs[3].minimum}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor minimo de ingresos"
                      defaultValue={riskVariables.IncomeLegal[3]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo 3</label>
                    <input
                      ref={incomeLegalRefs[3].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.IncomeLegal[3]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.IncomeLegal[3]?.data}
                    </label>
                    <input
                      ref={incomeLegalRefs[3].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.IncomeLegal[3]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo 2</label>
                    <input
                      ref={incomeLegalRefs[4].minimum}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor minimo de ingresos"
                      defaultValue={riskVariables.IncomeLegal[4]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo 2</label>
                    <input
                      ref={incomeLegalRefs[4].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.IncomeLegal[4]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.IncomeLegal[4]?.data}
                    </label>
                    <input
                      ref={incomeLegalRefs[4].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.IncomeLegal[4]?.value}
                    />
                  </div>
                </div>
                <div className="boxmin_max_mdr">
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">Minimo 1</label>
                    <input
                      ref={incomeLegalRefs[5].minimum}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor minimo de ingresos"
                      defaultValue={riskVariables.IncomeLegal[5]?.minimum}
                    />
                  </div>

                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">maximo 1</label>
                    <input
                      ref={incomeLegalRefs[5].maximum}
                      className="inputvarmatriz"
                      placeholder="Valor maximo de ingresos"
                      type="text"
                      defaultValue={riskVariables.IncomeLegal[5]?.maximum}
                    />
                  </div>
                  <div className="box-input-matrz">
                    <label className="tittle-input-mtriz">
                      {riskVariables.IncomeLegal[5]?.data}
                    </label>
                    <input
                      ref={incomeLegalRefs[5].value}
                      className="inputvarmatriz"
                      type="text"
                      placeholder="Valor de la matriz (1 a 5)"
                      defaultValue={riskVariables.IncomeLegal[5]?.value}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">Ubicacion geografica</p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.GeographicLocation[0]?.data}
                  </label>
                  <input
                    ref={geographicLocationRefs[0].value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.GeographicLocation[0]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    Distinto a Provincia de Buenos Aires
                  </label>
                  <input
                    ref={geographicLocationRefs[1].value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.GeographicLocation[1]?.value}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">Canal</p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.Canal[0]?.data}
                  </label>
                  <input
                    ref={typeCanalRefs[0].value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.Canal[0]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.Canal[1]?.data}
                  </label>
                  <input
                    ref={typeCanalRefs[1].value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.Canal[1]?.value}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">Actividad que desarrolla</p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.ActivityBeingCarriedOut[0]?.data}
                  </label>
                  <input
                    ref={activityBeingCarriedOutRefs[0]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={
                      riskVariables.ActivityBeingCarriedOut[0]?.value
                    }
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.ActivityBeingCarriedOut[1]?.data}
                  </label>
                  <input
                    ref={activityBeingCarriedOutRefs[1]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={
                      riskVariables.ActivityBeingCarriedOut[1]?.value
                    }
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.ActivityBeingCarriedOut[2]?.data}
                  </label>
                  <input
                    ref={activityBeingCarriedOutRefs[2]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={
                      riskVariables.ActivityBeingCarriedOut[2]?.value
                    }
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">Antiguedad en la actividad</p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.ActivitySeniority[0]?.data}
                  </label>
                  <input
                    ref={activitySeniorityRefs[0]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.ActivitySeniority[0]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.ActivitySeniority[1]?.data}
                  </label>
                  <input
                    ref={activitySeniorityRefs[1]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.ActivitySeniority[1]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.ActivitySeniority[2]?.data}
                  </label>
                  <input
                    ref={activitySeniorityRefs[2]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.ActivitySeniority[2]?.value}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">Tipo de operatoria</p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.TypeOperation[0]?.data}
                  </label>
                  <input
                    ref={typeOperationRefs[0]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.TypeOperation[0]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.TypeOperation[1]?.data}
                  </label>
                  <input
                    ref={typeOperationRefs[1]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.TypeOperation[1]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.TypeOperation[2]?.data}
                  </label>
                  <input
                    ref={typeOperationRefs[2]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.TypeOperation[2]?.value}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">Tipo de cliente</p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.TypeCustomer[0]?.data}
                  </label>
                  <input
                    ref={typeCustomerRefs[0]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.TypeCustomer[0]?.value}
                  />
                </div>
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.TypeCustomer[1]?.data}
                  </label>
                  <input
                    ref={typeCustomerRefs[1]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.TypeCustomer[1]?.value}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var">
              <div>
                <p className="tittle-matriz-var">
                  Presentacion de documentacion
                </p>
              </div>
              <div className="box-input-matriz-var">
                <div className="box-input-matrz">
                  <label className="tittle-input-mtriz">
                    {riskVariables.Documentation[0]?.data}
                  </label>
                  <input
                    ref={documentationRefs[0]?.value}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.Documentation[0]?.value}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var2">
              <div className="total-value-matr">
                <div className="box-matrix-min-max">
                  <p className="tittle-matriz-dawn">
                    {riskVariables.MDRLowNumber[0]?.data} Minimo
                  </p>
                  <input
                    ref={mdrLowNumberRefs[0]?.min_number}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.MDRLowNumber[0]?.min_number}
                  />
                </div>
                <div className="box-matrix-min-max">
                  <p className="tittle-matriz-dawn">
                    {riskVariables.MDRLowNumber[0]?.data} max
                  </p>
                  <input
                    ref={mdrLowNumberRefs[0]?.max_number}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.MDRLowNumber[0]?.max_number}
                  />
                </div>
              </div>
              <div className="total-value-matr">
                <div className="box-matrix-min-max">
                  <p className="tittle-matriz-mid">
                    {riskVariables.MDRMidNumber[0]?.data} min
                  </p>
                  <input
                    ref={mdrMidNumberRefs[0]?.min_number}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.MDRMidNumber[0]?.min_number}
                  />
                </div>
                <div className="box-matrix-min-max">
                  <p className="tittle-matriz-mid">
                    {riskVariables.MDRMidNumber[0]?.data} max
                  </p>
                  <input
                    ref={mdrMidNumberRefs[0]?.max_number}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.MDRMidNumber[0]?.max_number}
                  />
                </div>
              </div>
              <div className="total-value-matr">
                <div>
                  <p className="tittle-matriz-max">
                    {riskVariables.MDRHighNumber[0]?.data} min
                  </p>
                  <input
                    ref={mdrHighNumberRefs[0]?.min_number}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.MDRHighNumber[0]?.min_number}
                  />
                </div>
                <div className="box-matrix-min-max">
                  <p className="tittle-matriz-max">
                    {riskVariables.MDRHighNumber[0]?.data} max
                  </p>
                  <input
                    ref={mdrHighNumberRefs[0]?.max_number}
                    className="inputvarmatriz"
                    type="text"
                    defaultValue={riskVariables.MDRHighNumber[0]?.max_number}
                  />
                </div>
              </div>
            </div>
            <div className="seccion-matriz-var2">
              <button className="button-save-matriz" onClick={handleSubmit}>
                Guardar
              </button>
            </div>
          </div>
        </>
      ) : (
        <div className="loader"></div>
      )}
      <div></div>
      <FooterIndex />
    </div>
  );
};

export default FormVarMatriz;
